import { ChevronDownIcon } from '@langchain/untitled-ui-icons';

import { useMemo } from 'react';

import { PopoverDropdownMenu } from '@/components/PopoverDropdownMenu';

const DEFAULT_METADATA_KEY = 'Experiment';
const EXCLUDED_METADATA_KEYS = ['dataset_splits', 'num_repetitions'];

export const SelectChartsXAxisLabel = ({
  experimentMetadataPath,
  aggregateMetadataKeys: aggregateMetadataKeysProp,
  setExperimentMetadataPath,
}: {
  experimentMetadataPath?: string;
  aggregateMetadataKeys?: string[];
  setExperimentMetadataPath?: (path?: string) => void;
}) => {
  const aggregateMetadataKeys = useMemo(() => {
    const filteredAggregateMetadataKeys = aggregateMetadataKeysProp?.filter(
      (key) => !EXCLUDED_METADATA_KEYS.includes(key)
    );
    if (filteredAggregateMetadataKeys?.length === 0) {
      return [];
    }
    return [DEFAULT_METADATA_KEY, ...(filteredAggregateMetadataKeys ?? [])];
  }, [aggregateMetadataKeysProp]);

  return (
    setExperimentMetadataPath &&
    aggregateMetadataKeys.length > 0 && (
      <PopoverDropdownMenu
        values={aggregateMetadataKeys}
        getTitle={(value) => value}
        onSelect={(value) => {
          // unselect if the same value is selected
          if (value === experimentMetadataPath) {
            setExperimentMetadataPath(undefined);
          } else {
            setExperimentMetadataPath?.(value);
          }
        }}
        getIsSelected={(value) =>
          value === experimentMetadataPath ||
          (value === DEFAULT_METADATA_KEY && !experimentMetadataPath)
        }
      >
        <div className="rounded-md border border-secondary bg-background px-2 py-1 text-xs font-medium">
          <div className="flex items-center gap-2">
            <span>x-axis</span>
            <span className="rounded-[3px] bg-quaternary px-1">
              {experimentMetadataPath ?? DEFAULT_METADATA_KEY}
            </span>
            <ChevronDownIcon className="h-4 w-4" />
          </div>
        </div>
      </PopoverDropdownMenu>
    )
  );
};
